export default "__VITE_ASSET__ClUMCPEQ__"